import React, { Component } from 'react';
import { combineReducers } from 'redux';

import * as actions from './BotIntelligence.ducks';
import { default as Page } from './BotIntelligence.ducks';
import { default as SearchFilters } from './containers/SearchFilters/SearchFilters.ducks';
import { default as AddToGroupModal } from './containers/AddToGroupModal/AddToGroupModal.ducks';

const reducer = combineReducers({
  AddToGroupModal,
  Page,
  SearchFilters
});

class BotDetectionLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      component: null
    };
  }

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    return import(/* webpackChunkName: "zen/BotIntelligence.zen" */ './BotIntelligence')
      .then((BotIntelligence) => {
        this.setState({component: BotIntelligence.default});
      }).catch(
      // eslint-disable-next-line no-console
        (error) => console.error('An error occurred while loading \'BotIntelligence\'',error)
      );
  }

  render () {
    return (
      <span>{this.state.component && (<this.state.component {...this.props} />)}</span>
    );
  }
}

export default BotDetectionLoader;
export { default as sagas } from './BotIntelligence.sagas';
export { actions, reducer };
